/**
 * 节流
 * 持续事件过程中，隔一段时间再调用一次业务函数
 * @param {(...args: any[]) => void} fn 业务函数
 * @param {number} [threshhold=250] 节流阈值
 * @returns {(...rest: any[]) => void}
 */
function throttle(fn, threshhold = 250) {
    let last = 0;
    let deferTimer = null;
    return (...rest) => {
        const now = +new Date();
        if (now < last + threshhold) {
            deferTimer && clearTimeout(deferTimer);
            deferTimer = setTimeout(() => {
                deferTimer = null;
                last = now;
                fn(...rest);
            }, threshhold);
            return;
        }
        last = now;
        fn(...rest);
    };
}
export default throttle;
//# sourceMappingURL=throttle.js.map